import {createSelector} from '@reduxjs/toolkit'

export const agencyApplicationSelector = createSelector(
    [(state) => state.primaryAgencyApplication?.application], 
    (agencyApplication) => {
        return {
            agencyApplication : agencyApplication ?? {}
        }
    }
)


export const cachePropertiesSelector = createSelector(
    (state) => state.primaryAgencyApplication?.mortgageCacheProperties, 
    (mortgageCacheProperties) => {
        return mortgageCacheProperties || {}
    }
)